import { render, staticRenderFns } from "./IconInviteFriend.vue?vue&type=template&id=fdb7bcea&scoped=true"
import script from "./IconInviteFriend.vue?vue&type=script&lang=js"
export * from "./IconInviteFriend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb7bcea",
  null
  
)

export default component.exports